var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scY > 300),expression:"scY > 300"}],staticClass:"shape",attrs:{"id":"pagetop"},on:{"click":_vm.toTop}},[_vm._v(" Top ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }